export default __webpack_public_path__ + "static/media/user-3-fill-1.23b78a77.svg";